/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DestinationUpdateAWSKinesis,
  DestinationUpdateAWSKinesis$inboundSchema,
  DestinationUpdateAWSKinesis$Outbound,
  DestinationUpdateAWSKinesis$outboundSchema,
} from "./destinationupdateawskinesis.js";
import {
  DestinationUpdateAwss3,
  DestinationUpdateAwss3$inboundSchema,
  DestinationUpdateAwss3$Outbound,
  DestinationUpdateAwss3$outboundSchema,
} from "./destinationupdateawss3.js";
import {
  DestinationUpdateAWSSQS,
  DestinationUpdateAWSSQS$inboundSchema,
  DestinationUpdateAWSSQS$Outbound,
  DestinationUpdateAWSSQS$outboundSchema,
} from "./destinationupdateawssqs.js";
import {
  DestinationUpdateAzureServiceBus,
  DestinationUpdateAzureServiceBus$inboundSchema,
  DestinationUpdateAzureServiceBus$Outbound,
  DestinationUpdateAzureServiceBus$outboundSchema,
} from "./destinationupdateazureservicebus.js";
import {
  DestinationUpdateGCPPubSub,
  DestinationUpdateGCPPubSub$inboundSchema,
  DestinationUpdateGCPPubSub$Outbound,
  DestinationUpdateGCPPubSub$outboundSchema,
} from "./destinationupdategcppubsub.js";
import {
  DestinationUpdateHookdeck,
  DestinationUpdateHookdeck$inboundSchema,
  DestinationUpdateHookdeck$Outbound,
  DestinationUpdateHookdeck$outboundSchema,
} from "./destinationupdatehookdeck.js";
import {
  DestinationUpdateRabbitMQ,
  DestinationUpdateRabbitMQ$inboundSchema,
  DestinationUpdateRabbitMQ$Outbound,
  DestinationUpdateRabbitMQ$outboundSchema,
} from "./destinationupdaterabbitmq.js";
import {
  DestinationUpdateWebhook,
  DestinationUpdateWebhook$inboundSchema,
  DestinationUpdateWebhook$Outbound,
  DestinationUpdateWebhook$outboundSchema,
} from "./destinationupdatewebhook.js";

export type DestinationUpdate =
  | DestinationUpdateWebhook
  | DestinationUpdateAWSSQS
  | DestinationUpdateRabbitMQ
  | DestinationUpdateHookdeck
  | DestinationUpdateAWSKinesis
  | DestinationUpdateAzureServiceBus
  | DestinationUpdateAwss3
  | DestinationUpdateGCPPubSub;

/** @internal */
export const DestinationUpdate$inboundSchema: z.ZodType<
  DestinationUpdate,
  z.ZodTypeDef,
  unknown
> = z.union([
  DestinationUpdateWebhook$inboundSchema,
  DestinationUpdateAWSSQS$inboundSchema,
  DestinationUpdateRabbitMQ$inboundSchema,
  DestinationUpdateHookdeck$inboundSchema,
  DestinationUpdateAWSKinesis$inboundSchema,
  DestinationUpdateAzureServiceBus$inboundSchema,
  DestinationUpdateAwss3$inboundSchema,
  DestinationUpdateGCPPubSub$inboundSchema,
]);
/** @internal */
export type DestinationUpdate$Outbound =
  | DestinationUpdateWebhook$Outbound
  | DestinationUpdateAWSSQS$Outbound
  | DestinationUpdateRabbitMQ$Outbound
  | DestinationUpdateHookdeck$Outbound
  | DestinationUpdateAWSKinesis$Outbound
  | DestinationUpdateAzureServiceBus$Outbound
  | DestinationUpdateAwss3$Outbound
  | DestinationUpdateGCPPubSub$Outbound;

/** @internal */
export const DestinationUpdate$outboundSchema: z.ZodType<
  DestinationUpdate$Outbound,
  z.ZodTypeDef,
  DestinationUpdate
> = z.union([
  DestinationUpdateWebhook$outboundSchema,
  DestinationUpdateAWSSQS$outboundSchema,
  DestinationUpdateRabbitMQ$outboundSchema,
  DestinationUpdateHookdeck$outboundSchema,
  DestinationUpdateAWSKinesis$outboundSchema,
  DestinationUpdateAzureServiceBus$outboundSchema,
  DestinationUpdateAwss3$outboundSchema,
  DestinationUpdateGCPPubSub$outboundSchema,
]);

export function destinationUpdateToJSON(
  destinationUpdate: DestinationUpdate,
): string {
  return JSON.stringify(
    DestinationUpdate$outboundSchema.parse(destinationUpdate),
  );
}
export function destinationUpdateFromJSON(
  jsonString: string,
): SafeParseResult<DestinationUpdate, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DestinationUpdate$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DestinationUpdate' from JSON`,
  );
}
